import { MutableRefObject, useEffect, useMemo } from 'react'

import { State } from 'features/locationMap/types'

export function useOverlaySnapshots(
  map: google.maps.Map | null,
  state: State,
  overlaysShouldUpdateRef: MutableRefObject<boolean>,
) {
  useEffect(() => {
    if (!map) return () => undefined

    state.now.forEach(overlay => {
      overlaysShouldUpdateRef.current = false

      overlay.geometry.setMap(map)

      const { path } = overlay.snapshot

      overlay.geometry.setPath(path ?? [])

      overlaysShouldUpdateRef.current = true
    })

    return () => {
      state.now.forEach(overlay => overlay.geometry.setMap(null))
    }
  }, [map, overlaysShouldUpdateRef, state.now])

  const topPoints = useMemo(() => {
    return state.now.map(o =>
      o.snapshot.path?.reduce((topPoint, currentPoint) =>
        currentPoint.lat() > topPoint.lat() ? currentPoint : topPoint,
      ),
    )
  }, [state.now])

  return { topPoints }
}
